import React, { useState, FormEvent } from 'react';
import './style.scss';
import AuthLayout from './auth-layout';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input, ToastMessage } from '@cokitchen/cokitchen-components';
import AuthService from 'services/auth.service';
import { ROUTE_KEYS } from 'utils/constants';
import { handleApiError } from 'utils/functions';

type ResetPasswordFormType = { password: string; confirm_password: string };
const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [formError, setFormError] = useState<Partial<ResetPasswordFormType>>({});

  const [formData, setFormData] = useState<ResetPasswordFormType>({
    password: '',
    confirm_password: ''
  });
  const [loading, setLoading] = useState(false);
  const routeToLogin = () => {
    navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}?from=reset-password`);
  };
  const isFormValid = () => {
    setFormError({});
    const password = formData.password;
    const confirm_password = formData.confirm_password;

    if (password === '' && confirm_password === '') {
      setFormError({
        password: 'Password is required',
        confirm_password: 'Password confirmation is required'
      });
      return false;
    }

    if (password === '') {
      setFormError({
        password: 'Password is required'
      });
      return false;
    }

    if (confirm_password === '') {
      setFormError({
        confirm_password: 'Password confirmation is required'
      });
      return false;
    }

    if (password !== confirm_password) {
      setFormError({ confirm_password: 'Passwords do not match' });
      return false;
    }

    return true;
  };

  const handleConfirm = async (e: FormEvent) => {
    e.preventDefault();
    if (!isFormValid()) return;
    setLoading(true);
    const payload = {
      token: token,
      password: formData.password
    };
    try {
      const res = await AuthService.resetPassword(payload);
      if (res) {
        toast(<ToastMessage type='success' message={'Password succesfully reset'} />);
        routeToLogin();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const updateFormData = (key: string, value: string) => {
    setFormError((p) => ({ ...p, [key]: false }));
    setFormData((p) => ({ ...p, [key]: value }));
  };

  return (
    <div>
      <AuthLayout
        title='Reset Password'
        onConfirm={handleConfirm}
        loading={loading}
        subtitle='Enter the email, you signed up with, we will send you a link to create a new password'>
        <div className='flex flex-col gap-7'>
          <Input
            design='bordered'
            placeholder='Password'
            label='Password'
            type='password'
            error={formError.password}
            value={formData.password}
            onChange={(e) => updateFormData('password', e.target.value)}
          />
          <Input
            design='bordered'
            placeholder='Confirm Password'
            label='Confirm Password'
            type='password'
            error={formError.confirm_password}
            value={formData.confirm_password}
            onChange={(e) => updateFormData('confirm_password', e.target.value)}
          />
        </div>
      </AuthLayout>
    </div>
  );
};

export default ResetPassword;
